import getRoute from './utils/getRoute';

// Constants
export const DEFAULT_CITY = 'jakarta';

// City configs
const CITY_CONFIGS = {
  blr: {
    city: {
      name: 'Bengaluru',
      code: 'blr',
      bounds: {
        lowerLat: 12.8,
        upperLat: 13.15,
        lowerLong: 77.4,
        upperLong: 77.75,
      },
    },
  },
  goa: {
    city: {
      name: 'Goa',
      code: 'goa',
      bounds: {
        lowerLat: 15.1,
        upperLat: 15.9,
        lowerLong: 73.75,
        upperLong: 74.15,
      },
    },
  },
  kochi: {
    city: {
      name: 'Kochi',
      code: 'kochi',
      bounds: {
        lowerLat: 9.8,
        upperLat: 10.2,
        lowerLong: 76.25,
        upperLong: 76.55,
      },
    },
  },
  chennai: {
    city: {
      name: 'Chennai',
      code: 'chennai',
      bounds: {
        lowerLat: 12.85,
        upperLat: 13.35,
        lowerLong: 80.0,
        upperLong: 80.4,
      },
    },
  },
  delhi: {
    city: {
      name: 'Delhi',
      code: 'delhi',
      bounds: {
        lowerLat: 28.35,
        upperLat: 28.95,
        lowerLong: 76.95,
        upperLong: 77.55,
      },
    },
  },
  pune: {
    city: {
      name: 'Pune',
      code: 'pune',
      bounds: {
        lowerLat: 18.35,
        upperLat: 18.75,
        lowerLong: 73.65,
        upperLong: 74.05,
      },
    },
  },
  jaipur: {
    city: {
      name: 'Jaipur',
      code: 'jaipur',
      bounds: {
        lowerLat: 26.70,
        upperLat: 27.05,
        lowerLong: 75.45,
        upperLong: 76.05,
      },
    },
  },
  jakarta: {
    city: {
      name: 'Jakarta',
      code: 'jakarta',
      bounds: {
        lowerLat: -6.45,
        upperLat: -5.95,
        lowerLong: 106.55,
        upperLong: 107.1,
      }
    }
  },
  railways: {
    city: {
      name: 'Railways',
      code: 'railways',
      bounds: {
        lowerLat: -5,
        upperLat: 45,
        lowerLong: 70,
        upperLong: 100,
      },
    },
  },
};
// Available cities for dropdown
export const AVAILABLE_CITIES = Object.entries(CITY_CONFIGS).map(x => x[1].city.code);

export const getCurrentCity = () => {
  try {
    const { city } = getRoute();
    return city || DEFAULT_CITY;
  } catch (e) {
    return DEFAULT_CITY;
  }
};

export const isCitySupported = (cityCode) => {
  return !!CITY_CONFIGS[cityCode];
};

export const getConfigForCity = (cityCode) => {
  const config = CITY_CONFIGS[cityCode] || CITY_CONFIGS[DEFAULT_CITY];
  if (!config) {
    console.error(`No config found for city ${cityCode}`);
    return null;
  }
  return config;
};

export const getCityBounds = () => {
  const config = getConfigForCity(getCurrentCity());
  if (!config?.city?.bounds) {
    console.error('Invalid city config:', config);
    return [0, 0, 0, 0]; // Safe fallback
  }

  const { lowerLat, upperLat, lowerLong, upperLong } = config.city.bounds;
  return [lowerLong, lowerLat, upperLong, upperLat];
};

export const getCityInfo = () => {
  const config = getConfigForCity(getCurrentCity());
  return config?.city;
};

// Default export returns current city's config
export default () => getConfigForCity(getCurrentCity());
